import React from 'react';
import Header from '../../components/Header';
import { MoveRight, BrainCircuit, Check } from 'lucide-react';
import Marquee from 'react-fast-marquee';
import ServicesFooter from '../../components/services/ServicesFooter';
const items = [
    'E-Commerce',
    'Roof Measurement',
    'AI',
    'SaaS',
    'Chatbots',
    'Automation',
    'interview AI',
    '',
];
const content = [
    {
        title: 'Boost Efficiency',
        description: 'Boost your efficiency with our AI-powered solutions.',
        icon: '/assets/images/boost-efficiency.png',
    },
    {
        title: 'Empower Your Team',
        description: 'Empower your team with AI-driven solutions.',
        icon: '/assets/images/empower-team.png',
    },
    {
        title: 'Accelerate Growth',
        description: 'Accelerate your growth with our AI-driven solutions.',
        icon: '/assets/images/accelerate-growth.png',
    },
];
const project = [
    {
        title: 'Roof Wise AI',
        description:
            'Roof Wise is an Al-powered roofing measurement and estimation platform designed to deliver precise cost insights to both homeowners and roofers in under five seconds.',
        image: '/assets/images/roof-ai.jpg',
    },
    {
        title: 'Interview Al',
        description:
            'Interview Al is a powerful platform designed to streamline HR processes and boost overall company productivity. ',
        image: '/assets/images/inter-ai.jpg',
    },
];
const AiServices = () => {
    return (
        <>
            <Header />
            <HeroSection />
            <WhyMatters />
            <IntegrationSection />
            <OurProjects />
            <ToolsContent />
            <ServicesFooter content='Empower Your Business with AI-Driven Solutions. Unlock the Power of Generative AI for Your Success.' />
        </>
    );
};

export default AiServices;

const HeroSection = () => {
    return (
        <section className='background-gradient-color h-fit lg:h-full text-white relative overflow-hidden -mt-24 hero-image'>
            <div className='gradient top -z-1'></div>
            <div className='gradient bottom  -z-1'></div>
            <div className='relative isolate px-6 pt-20 pb-20 lg:px-8 z-50'>
                <div className='mx-auto max-w-4xl pt-36 pb-20 sm:py-48 lg:py-56'>
                    <div className='text-center'>
                        <h1 className='text-5xl font-light tracking-tight text-balance text-white  sm:text-7xl'>
                            Power
                            <span
                                className='px-3 inline-block text-transparent bg-clip-text'
                                style={{
                                    backgroundImage:
                                        'linear-gradient(50deg, #714DFF, #9C83FF 31.28%, #E151FF 77.97%, #FFF759 95.64%)',
                                }}
                            >
                                Generative AI
                            </span>
                            <br /> With Your Data.
                        </h1>
                        <p className='mt-8 text-lg font-light text-pretty text-white max-w-4xl'>
                            Accelerate Innovation, Reduce Costs, and Empower Your Teams with AI.
                            Elevate Your Business with AI-Driven Solutions. Unlock the Power of
                            Generative AI for Your Success.
                        </p>
                    </div>
                    <div className='block space-y-5 md:space-y-0 text-center md:flex justify-center gap-5 mt-20 '>
                        <a
                            href='/book-a-call'
                            className='cursor-pointer  bg-white rounded-md text-black mx-auto md:mx-0 px-5 py-3 font-normal w-44 flex text-center justify-center items-center  gap-x-2'
                        >
                            Let's Talk <MoveRight className='h-4 w-4' />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
const WhyMatters = () => {
    return (
        <section className='bg-black'>
            <div className='max-w-6xl mx-auto relative z-10'>
                <div>
                    <h2 className='text-2xl lg:text-4xl font-light text-white text-center md:text-start'>
                        Why AI Matters for Your Business
                    </h2>
                </div>
                <div>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pt-10 md:pt-24 px-5 md:px-0'>
                        {content.map((item, index) => (
                            <div key={index} className=' p-2 shadow-md overflow-hidden'>
                                <div className='relative'>
                                    <img
                                        src={item.icon}
                                        alt='GIF Icon'
                                        className='w-20 mx-auto mb-5 rounded-md object-cover'
                                    />
                                    {/* Gradient overlay */}
                                    <div className='w-full p-4 text-center'>
                                        <h3 className='text-xl font-semibold text-white'>
                                            {item.title}
                                        </h3>
                                        <p className='text-sm text-white mt-2 text-center font-light px-8'>
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
const ToolsContent = () => {
    return (
        <section className='background-gradient-color'>
            <div className='gradient top -z-1'></div>
            <div className='gradient bottom  -z-1'></div>
            <div className='max-w-6xl mx-auto relative z-50 py-10 md:pt-20'>
                <div className='text-white'>
                    <h3 className='text-xl font-extralight pb-2 lg:pb-5 text-center md:text-start'>
                        Tools for all your needs
                    </h3>
                    <h1 className='text-2xl lg:text-4xl font-light text-white text-center md:text-start'>
                        Embedded into the enterprise ecosystem to Let's make your business Al
                        powered!
                    </h1>
                    <h6 className='text-xl uppercase text-white py-5 text-center md:text-start'>
                        <BrainCircuit className='inline-block' /> L L M S
                    </h6>
                </div>
                <div className='py-20'>
                    <Marquee autoFill={true} pauseOnClick={false}>
                        <div className='px-10'>
                            <img src='/assets/images/llama.png' alt='' className='h-full w-24' />
                        </div>
                        <div className='px-10'>
                            <img
                                src='/assets/images/openai-logo.png'
                                alt=''
                                className='h-full w-24'
                            />
                        </div>
                        <div className='px-10'>
                            <img src='/assets/images/deepseek.png' alt='' className='h-full w-24' />
                        </div>
                        <div className='px-10'>
                            <img src='/assets/images/bedrock.png' alt='' className='h-full w-24' />
                        </div>
                        <div className='px-10'>
                            <img src='/assets/images/gemini.png' alt='' className='h-full w-24' />
                        </div>
                        <div className='px-10'>
                            <img
                                src='/assets/images/data-bricks.png'
                                alt=''
                                className='h-full w-24'
                            />
                        </div>
                    </Marquee>
                </div>
            </div>
        </section>
    );
};

const OurProjects = () => {
    return (
        <section className='bg-black'>
            <div className='max-w-6xl mx-auto relative z-10 pb-20'>
                <div className='text-white'>
                    <h3 className='text-xl font-extralight pb-2 lg:pb-5 text-center md:text-start'>
                        In the spotlight
                    </h3>
                    <h1 className='text-2xl lg:text-4xl font-light text-white text-center md:text-start'>
                        Latest Projects
                    </h1>
                    <h6 className='text-xl uppercase text-white py-5'></h6>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 px-5 md:px-0 space-x-0 md:space-x-5'>
                    <ProjectCard />
                </div>
            </div>
        </section>
    );
};
const ProjectCard = () => {
    return (
        <>
            {project.map((item, index) => (
                <div
                    key={index}
                    className='bg-white/30 backdrop-blur-md rounded-md p-2 md:p-5 shadow-md mb-5 md:mb-0'
                >
                    <img src={item.image} alt='' className='h-64 md:h-96 rounded-md w-full' />
                    <h3 className='text-xl font-light text-white pt-5'>{item.title}</h3>
                    <p className='text-sm font-light text-white pt-3'>{item.description}</p>
                </div>
            ))}
        </>
    );
};

const IntegrationSection = () => {
    return (
        <section className='py-20 px-4 bg-black text-white'>
            <div className='max-w-6xl mx-auto'>
                {/* Heading */}
                <h2 className='text-2xl lg:text-4xl font-light text-white'>
                    Integrate to Innovate / Open Your AI Future
                </h2>
                <p className='text-xl font-extralight pb-2 lg:pb-5 text-white pt-5'>
                    Minimal Disruption, Maximum Flexibility
                </p>
                <div className='flex justify-center items-center md:pt-0 py-10 md:hidden w-full'>
                    <img
                        src='/assets/images/visual.png'
                        alt='Visual'
                        className='h-96 w-80 object-contain'
                    />
                </div>

                {/* Paragraphs */}
                <div className='grid grid-cols-1 gpa-x-5 md:grid-cols-2'>
                    <div className='space-y-4 text-gray-300 text-left max-w-4xl items-center my-auto'>
                        <p className='text-lg font-light flex'>
                            <Check className='h-10 w-10 mr-4' /> Seamlessly integrate AI into your
                            current infrastructure with minimal downtime. Our platform is designed
                            to work with your existing workflows, reducing the learning curve and
                            deployment delays.
                        </p>
                        <p className='text-lg font-light flex'>
                            <Check className='h-10 w-10 mr-4' />
                            Support for open-source frameworks and bring-your-own-model flexibility
                            means you’re never locked in. Run your own AI or build on top of
                            ours—it's your choice.
                        </p>
                        <p className='text-lg font-light flex'>
                            <Check className='h-10 w-10 mr-4' />
                            Compatible with all cloud environments—public, private, and hybrid—so
                            you can scale AI solutions across ecosystems without compromise.
                        </p>
                    </div>
                    <div className='text-center mx-auto md:pt-0 pt-10 md:block hidden'>
                        <img src='/assets/images/visual.png' alt='' className=' h-96 w-80' />
                    </div>
                </div>
            </div>
        </section>
    );
};
